import { render, staticRenderFns } from "./RecommendedCourseRotationChart.vue?vue&type=template&id=805f4be2&scoped=true&"
import script from "./recommendedCourseRotationChart.js?vue&type=script&lang=js&"
export * from "./recommendedCourseRotationChart.js?vue&type=script&lang=js&"
import style0 from "./RecommendedCourseRotationChart.vue?vue&type=style&index=0&id=805f4be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805f4be2",
  null
  
)

export default component.exports